import React from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardActionArea from "@mui/material/CardActionArea";
/* import CardActions from "@mui/material/CardActions"; */
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Grid from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import EditarBanner from "./CrearBanner";
/* import ViewBanner from "./ViewBanner"; */
import EliminarBanner from "./EliminarBanner";
import { Draggable } from "react-beautiful-dnd";
import { Avatar } from "@mui/material";
import { blue } from "@mui/material/colors";
import LinkMaterial from "@mui/material/Link";
import { Link } from "react-router-dom";

const styles = {
  img_devices_container: {
    height: 90,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  img_devices: {
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "auto 100px",
    height: "100%",
    width: "100%",
  },
  media: {
    height: 140,
  },
  avatar: {
    width: "1rem",
    height: "1rem",
  },
  avatar_floating: {
    position: "relative",
    top: 2,
    width: "2rem",
    height: "2rem",
    color: (theme) => theme.palette.getContrastText(blue[500]),
    backgroundColor: blue[400],
  },
};

export default function CardBanner({
  index,
  banner,
  update,
  setUpdate,
  courses,
  setSnackbar,
}) {
  return (
    <Draggable key={banner.id} draggableId={`${banner._id}`} index={index}>
      {(provided) => (
        <Grid
          size={{ xs: 12, md: 3 }}
          ref={provided.innerRef}
          {...provided.draggableProps}
        >
          <Avatar sx={styles.avatar_floating}>{index + 1}</Avatar>
          <Card>
            <CardHeader
              style={{
                paddingTop: 4,
                paddingBottom: 4,
                display: "flex",
                justifyContent: "space-around",
              }}
              action={[
                <EliminarBanner
                  key="delete"
                  aria-label="deleting"
                  banner={banner}
                  setUpdate={setUpdate}
                  update={update}
                />,
                <EditarBanner
                  key="editing"
                  aria-label="editing"
                  banner={banner}
                  setUpdate={setUpdate}
                  update={update}
                  view="editar"
                  courses={courses}
                  setSnackbar={setSnackbar}
                />,
                <IconButton
                  disableRipple
                  aria-label="drag"
                  key="dragable"
                  {...provided.dragHandleProps}
                >
                  <DragIndicatorIcon />
                </IconButton>,
              ]}
              /* title={<Avatar className={styles.avatar}>{index+1}</Avatar>} */
            />
            <CardActionArea>
              <LinkMaterial
                component={Link}
                to={banner.course_ref ? `/curso/${banner.course_ref}` : "#"}
                underline="none"
                color="inherit"
                target={banner.course_ref ? "_blank" : null}
              >
                <CardMedia
                  sx={styles.media}
                  image={banner.image_desktop}
                  title={
                    banner.course_name
                      ? `banner uniline ${banner.course_name}`
                      : `banner uniline ${banner.key_desktop}`
                  }
                />
                <CardContent>
                  <Typography color="textSecondary" noWrap>
                    {banner.course_name ? banner.course_name : `No vinculado`}
                  </Typography>
                  {/* <Box display="flex">
              <Grid container spacing={1}>
                <Grid item sm={6} xs={12}>
                  <Typography gutterBottom variant="subtitle1" component="h2">
                    Imagen para dispositivos moviles
                  </Typography>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <Box
                    boxShadow={1}
                    className={styles.img_devices}
                    style={{ backgroundImage: `url(${banner.image_devices})` }}
                  >
                  </Box>
                </Grid>
              </Grid>
            </Box> */}
                </CardContent>
              </LinkMaterial>
            </CardActionArea>
            {/* <CardActions style={{ justifyContent: "space-around" }}>
          <ViewBanner banner={banner} />
          <EditarBanner
            banner={banner}
            setUpdate={setUpdate}
            update={update}
            view="editar"
            courses={courses}
          />
          <EliminarBanner
            banner={banner}
            setUpdate={setUpdate}
            update={update}
          />
        </CardActions> */}
          </Card>
        </Grid>
      )}
    </Draggable>
  );
}
